import { Controller } from "@hotwired/stimulus"

// Alterna entre password y text en el campo de contraseña.
const SHOW = "Mostrar"
const HIDE = "Ocultar"

export default class extends Controller {
  static targets = ["input", "label"]

  toggle() {
    const hidden = this.inputTarget.type === "password"
    this.inputTarget.type = hidden ? "text" : "password"
    this.labelTarget.textContent = hidden ? HIDE : SHOW
  }
}
